<div class="pop-bg">
</div>

<div class="pop-position">

    <div class="row col-md-12 p-0 grey header-popup-box">
        <span class="col-md-10 col-sm-10 p-0">
            <div class="heading-panel">
                <span class="text-sm text-ellipsis heading-txt flex ml-10">Setting Template</span>
            </div>
        </span>
        <span class="pull-right text-right col-md-2 col-sm-2 pv-10 cursor" (click)="closeModel()">
            <i class="fa fa-times" aria-hidden="true"></i>
        </span>
    </div>
    <div class="col-md-12 p-0 mt-10">
        <div class="col-md-12 col-sm-12 col-xs-12 mb-10 p-0">
            <div *ngFor="let a of templatelist; let i = index" class="col-md-12 col-sm-12 col-xs-12 p-0 row"
                style="margin-bottom:0.5rem !important">
                <div class="col-md-6">
                    <label class="w-100">{{a.type.split("_").join(" ") + ':*'}}</label>
                    <div class="file-upload-wrapper inventory-provider" [attr.data-text]="a.uploadname">
                        <input name="file-upload-field" (change)="OnChange($event,a.type,i);"
                            onclick="this.value = null" type="file" accept=".pdf">
                    </div>
                </div>
                <div class="col-md-6 btnSection">
                    <button [disabled]="a.uploadname == 'No File Chosen' || disableUpload"
                        (click)="uploadAppealTemplate(a.type);"
                        class="btn pr-upl label btn-default label-info-padding label-info square-btn cursor mr-10 mt-0">
                        Upload</button>
                    <button [disabled]="a.uploadedurl == ''" (click)="viewUploadedFile(a.type)"
                        class="btn pr-upl label btn-default label-info-padding label-info square-btn cursor mr-10 mt-0">
                        Download </button>
                    <button [disabled]="a.delete == ''" (click)="deleteUploadedFile(a.type)"
                        class=" btn pr-upl label btn-default label-info-padding label-info square-btn cursor mr-0 mt-0"> Delete</button>
                </div>
                <span>

                </span>
            </div>
        </div>
    </div>
</div>
